import { Component, OnInit } from '@angular/core';
import { DropzoneConfigInterface } from 'angular2-dropzone-wrapper';
import { environment } from '../../../../environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-import-position-page',
  templateUrl: './import-position-page.component.html',
  styleUrls: ['./import-position-page.component.scss']
})
export class ImportPositionPageComponent implements OnInit {
  sub: any;
  orgId: number;
  config: DropzoneConfigInterface;

  constructor(private route: ActivatedRoute, private titleService: Title) { }

  positionsTemplateUrl = environment.positionsTemplateUrl;

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.orgId = +params['orgId'];
      this.config = {
        dictDefaultMessage: `<div class="text">
            <p>Drag completed file here</p>
            <p>or</p>
            <a style="border: 1px solid black;
              border-radius: 20px;
              background: transparent;
              color: black;
              padding: 10px">
              SELECT FILE
            </a>
          </div>`,
        dictFallbackMessage: '',
        server: `${environment.organizationsUrl}/${this.orgId}/documents/upload_file`,
        headers: {
          Authorization: `Bearer ${localStorage.onboardingToken}`,
        },
        maxFilesize: 2,
        acceptedFiles: 'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv',
        paramName: 'file',
        params: `file_type=miscellaneous`
      }
    });

    this.titleService.setTitle('Import Positions');
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }


  onUploadSuccess(e: any) {

  }

  onUploadError(e: any) {

  }

  onCancel(e: any) {

  }

}



// WEBPACK FOOTER //
// ./src/app/onboarding/components/import-position-page/import-position-page.component.ts